import React, {Component} from 'react';
import { connect }          from 'react-redux';
import './index.scss';

import * as routes from '../../../../constants/routes';

//components
import {sendBenefitCoupon} from "../../../../redux/actions";

//assets
import desktop_exit from 'assets/icons/login-x-icon.svg';
import radio_empty from 'assets/icons/radio-empty.svg'
import radio_checked from 'assets/icons/radio-checked.svg'
import {convertToSortedArray, formatNumber, getMediaPath} from "../../../../app/functions";

class RadioOptions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            selected_radio: this.props.selected,
        };
        this.animateOut  = this.animateOut.bind(this);
        this.animateIn   = this.animateIn.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();

        if(this.props.isAcquired){
            this.setState({step: 2});
        }
    }
    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleRadioOnClick = (item) =>{
        this.setState({selected_radio: item.id});
        const updatedPrice = this.isCashBack() ? item.cashback_price : item.price;
        const cashbackDescription = this.isCashBack() ? item.cashback_description : "";
        this.props.onChange(item.id, updatedPrice, item.old_price, item.cda, cashbackDescription );
    };

    isCashBack(){
        const trade_charge_type = this.props.benefit.main.trade_charge_type;// from getDetailedBenefitByIdForWeb
        const tradeBenefitsChargeTypes = this.props.TradeBenefitsChargeTypes;// from generalDeclaration
        return tradeBenefitsChargeTypes[trade_charge_type] === "cashback"
    }

    getContent = () =>{
        const data = convertToSortedArray(this.props.benefit.optionsArr.options);

        let res = [];


        data.forEach(item =>{
            const selected = item.id === this.state.selected_radio;
            const updatedPrice = this.isCashBack() ? item.cashback_price : item.price;
            res.push(
                <div className={'radio-wrapper ' + (selected ? 'selected' : '')}
                     onClick={() => this.handleRadioOnClick(item)}>
                    <img src={selected ? getMediaPath(radio_checked) : getMediaPath(radio_empty)} alt={item.title}/>
                    <div className='title-price'>
                        <span className='text'>{item.title}</span>
                        <span className='price'>{formatNumber(updatedPrice)}</span>
                    </div>
                </div>
            )
        });

        return res;
    };

    render() {

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper radio-group " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className="popup_content">
                        <button className="x_close_icon"
                                onClick={() => this.animateOut()}
                                aria-label="סגור"><img src={getMediaPath(desktop_exit)} alt='/'/>
                        </button>

                        <h3 className='title'>{this.props.transaction['radio_group_popup_title']}</h3>

                        <div className='radio-group'>
                            {this.getContent()}
                        </div>

                        <button className='submit-btn' onClick={()=> this.animateOut()}>{this.props.transaction['radio_group_popup_btn']}</button>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        transaction: store.config.Translations,
        benefit: store.data.BenefitPage,
        userDate: store.config.UserData,
        TradeBenefitsChargeTypes: store.config.TradeBenefitsChargeTypes,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        sendBenefitCoupon: (payload) => dispatch(sendBenefitCoupon(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(RadioOptions);